import { render, staticRenderFns } from "./heading_with_button.vue?vue&type=template&id=034fdc62&scoped=true&"
import script from "./heading_with_button.vue?vue&type=script&lang=js&"
export * from "./heading_with_button.vue?vue&type=script&lang=js&"
import style0 from "./heading_with_button.vue?vue&type=style&index=0&id=034fdc62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034fdc62",
  null
  
)

export default component.exports